export const stateName = 'intl';